module.exports = __webpack_public_path__ + "img/banner.9e6c6b52.png";